import { spacing } from './spacing';

export const inputStyle = {
    width: '443px',
    height: spacing[7],
    padding: `${spacing[1]} ${spacing[3]}`,
};
